export interface PaymentCardEntity {
  uid?: string;
  bankAccountUid: string;
  type: number;
  name: string;
  number: string;
  monthExpiring: number;
  yearExpiring: number;
  accountNumber?: string;
  projectUid?: string;
  expenseProjectTypeUid?: string;
}

export interface PaymentCardPayload {
  uid?: string;
  bankAccountUid: string;
  type: number;
  name: string;
  number: string;
  monthExpiring: number;
  yearExpiring: number;
  accountNumber?: string;
  projectUid?: string;
  expenseProjectTypeUid?: string;
}

export interface PaymentCardFormDialogData {
  uid: string | null;
  paymentCardType: number;
  paymentCard?: PaymentCardEntity | null;
}

export interface PaymentCardExpiryParts {
  month: number;
  year: number;
}

export function parsePaymentCardExpiry(value: string): PaymentCardExpiryParts | null {
  const text = String(value || '').trim();
  if (!text || !text.includes('/')) return null;
  const parts = text.split('/');
  const month = parseInt(parts[0], 10);
  const year = parseInt(parts[1], 10);
  if (isNaN(month) || month < 1 || month > 12 || isNaN(year) || year < 0) return null;
  return { month, year };
}

export function formatPaymentCardExpiry(month: number, year: number): string {
  const m = Number(month) || 0;
  const y = Number(year) || 0;
  if (!m || !y) return '';
  return (m < 10 ? '0' + m : String(m)) + '/' + (y < 10 ? '0' + y : String(y));
}

export function maskPaymentCardNumber(value: string): string {
  return String(value || '').replace(/\d(?=\d{4})/g, '*');
}
